import '../assets/css/motionDiv.css';
import { useRef } from "react";
import { motion } from "framer-motion";
import { useFollowPointer } from "./use_follow_pointer.js";

const MotionDiv = () => {
    const ref = useRef(null);
    const { x, y } = useFollowPointer(ref);

    return (
        <>
            <motion.div
                ref={ref}
                className={`box`}
                animate={{ x, y }}
                transition={{
                    type: "spring",
                    damping: 3,
                    stiffness: 50,
                    restDelta: 0.001
                }}

            />

            <motion.div
                ref={ref}
                className={`box2`}
                animate={{ x, y }}
                transition={{
                    type: "spring",
                    damping: 3,
                    stiffness: 50,
                    restDelta: 0.001
                }}

            />
        </>


    );
}

export default MotionDiv;